/* afzuigkapSpecialist.nl: collectiefilters, aantal resultaten in de toolbar en teller op de filterknop */
(function () {
  'use strict';

  function sync() {
    var src = document.querySelector('.wf-count');
    var tb = document.querySelector('.products-toolbar');
    if (!src || !tb) return;

    var total = src.getAttribute('data-total') || '0';
    var unit = total === '1' ? 'product' : 'producten';
    var active = parseInt(src.getAttribute('data-active'), 10) || 0;

    var el = tb.querySelector('.wf-toolbar-count');
    if (!el) {
      el = document.createElement('p');
      el.className = 'wf-toolbar-count';
      el.setAttribute('role', 'status');
      tb.insertBefore(el, tb.querySelector('.products-toolbar__layout'));
    }
    var text = total + ' ' + unit;
    if (el.getAttribute('data-text') !== text) {
      el.setAttribute('data-text', text);
      el.textContent = '';
      var strong = document.createElement('strong');
      strong.textContent = total;
      el.appendChild(strong);
      el.appendChild(document.createTextNode(' ' + unit));
    }

    var btn = tb.querySelector('.products-toolbar__filter-btn');
    if (btn) {
      var badge = btn.querySelector('.wf-badge');
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'wf-badge';
        btn.insertBefore(badge, btn.querySelector('svg'));
      }
      badge.textContent = '';
      if (active > 0) {
        badge.hidden = false;
        badge.appendChild(document.createTextNode(String(active)));
        var vh = document.createElement('span');
        vh.className = 'visually-hidden';
        vh.textContent = ' actief';
        badge.appendChild(vh);
      } else {
        badge.hidden = true;
      }
    }
  }

  sync();
  document.addEventListener('on:facet-filters:updated', sync);
})();
